import { IField, LocaleString } from "../../omnia"

type BooleanOption = "waterCourse" | "sensitiveHabitat" | "ancientMonument"

interface EditContext {
    readonly target: IField
    readonly locked: { [key in BooleanOption]: boolean }
    readonly multipleTargets: boolean
}

export function createSoilEditController(context: EditContext) {


    const booleanOptions = {
        ...createBooleanOption("waterCourse", "WaterCourse", "Water course" as LocaleString),
        ...createBooleanOption("sensitiveHabitat", "SensitiveHabitat", "Sensitive habitat" as LocaleString),
        ...createBooleanOption("ancientMonument", "AncientMonument", "Ancient monument" as LocaleString),
    }

    return {
        booleanOptions
    }

    function createBooleanOption(key: BooleanOption, prop: string, label: string) {

        return {
            [key]: {
                prop,
                label,

                get value() {
                    return context.multipleTargets && context.locked[key]
                        ? null
                        : context.target[prop]
                },

                set value(value: boolean) {

                    if (context.multipleTargets) {
                        context.locked[key] = value === null
                    }

                    context.target[prop] = value

                }
            }
        }

    }

}
